import OAviaSchedule from './o-avia-schedule.vue';

export default OAviaSchedule;